export default __webpack_public_path__ + "static/404-01e5f3191e2a7f0719799f97d79985e5.svg";